import ArImage from '../components/image-ar/ImageAr'

export default [
  { name: 'ImageAr', path: '/image-ar/:id', component: ArImage, meta: { navHidden: true, requiresAuth: false, fullscreen: true } }
]
